import React from 'react';
import { Box, Container, Heading } from '@hover/blueprint';

const Hero: React.FC = () => (
  <Box w="100%" bg="brandBrown.100" justifyContent="center" mb="56px">
    <Container
      maxW="1300px"
      pt={{ base: 600, tablet: 800 }}
      px={{ base: 500, tablet: '56px' }}
      pb={{ base: 800, tablet: '114px' }}
    >
      <Heading
        as="h1"
        color="brandNavy.500"
        style={{ marginBottom: 0 }}
        size={{ base: 500, tablet: 700, desktop: 800 }}
      >
        Cookie Policy
      </Heading>
    </Container>
  </Box>
);

export default Hero;
